import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './Layouts/Main';
import MedicalRecords from './Layouts/MedicalRecords';
import Main from './Layouts/Main';
import Minmax from './Layouts/MinmaxMobile';
import MinmaxQuery from './Layouts/MinmaxQuery';
import MinmaxQuery2 from './Layouts/MinmaxQuery2';
import MinmaxLogin from './Layouts/MinmaxLogin';
import AdminLogin from './Layouts/AdminLogin';
import GenerateReport from './Layouts/GenerateReport';
import LaborCheckForm from './Layouts/LaborCheckForm';
import GeneralForm from './Layouts/GeneralForm';
import AnnualReport from './Layouts/AnnualReport';
import AnnualReportCustomer from './Layouts/AnnualReportCustomer';
import QueryLostitem from './Layouts/QueryLostitem';


// import App from './App';
import reportWebVitals from './reportWebVitals';
import { SnackbarProvider, useSnackbar } from "notistack";
import { BrowserRouter as Router, Route, Routes, Redirect, HashRouter } from "react-router-dom";
import { Provider, useSelector, connect } from "react-redux";
import ClearIcon from '@mui/icons-material/Clear';
import { IconButton } from '@mui/material';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { createBrowserHistory, createHashHistory } from "history";
import { IntlProvider } from "react-intl";
import app_reducers from "./reducers/app";
import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from '@redux-devtools/extension';
import { indigo, grey, orange, blue } from '@mui/material/colors';
import PrivateRoute from './_Services/PrivateRoute';
import { createPersistedStore } from './_Services/persistConfig';
import { PersistGate } from 'redux-persist/integration/react'
const root = ReactDOM.createRoot(document.getElementById('root'));
const history = createBrowserHistory();
const rootReducer = (state = {}, action) => {
  return {
    app: app_reducers(state.app, action)
  };
};
// const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(thunk, logger)));  //logger要放在最後
//不允許上一頁
window.addEventListener("popstate", () => {
  history.go(1);
});
//不允許手動修改 Examine_ 前綴的 localStorage 項目
window.addEventListener("storage", (e) => {
  if (e.key && e.key.startsWith('Examine_')) {
    localStorage.setItem(e.key, e.oldValue);
  }
});
const { store, persistor } = createPersistedStore(rootReducer);

const notistackRef = React.createRef();
const onClickDismiss = key => () => {
  notistackRef.current.closeSnackbar(key);
}

const InitialSetting = () => {

  const { dark } = useSelector(state => ({
    dark: state.app.dark,
  }));
  const { app } = useSelector(state => ({
    app: state.app
  }));
  const theme = createTheme({
    // status: {
    //   danger: orange[500],
    // },
    typography: {
      button: {
        textTransform: 'none'
      }
    },
    components: {
      MuiFormLabel: {
        styleOverrides: {
          asterisk: {
            // fontSize:"20px",
            color: '#db3131',
            '&$error': {
              color: '#db3131'
            },
          },
          root: {
            color: dark ? "#1a90ff" : "black",
            "&$focused": dark ? { color: "#1a90ff" } : { color: indigo[500] }
          }
        }
      }
    },


    palette: {
      mode: dark ? "dark" : "light",
      primary: {
        main: dark ? blue[500] : indigo[500]
      },
      // secondary: {
      //   main: "#FFFFFF"
      // }
    }
  });
  return (
    <ThemeProvider theme={theme}>
      <IntlProvider locale={app.i18n.locale} messages={app.i18n.messages}>

        <SnackbarProvider
          maxSnack={3}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          ref={notistackRef}
          action={key => (
            <IconButton onClick={onClickDismiss(key)}>
              <ClearIcon />
            </IconButton>
          )}
        >
          <Router history={history} basename={process.env.PUBLIC_URL}>

            <Routes>
              {`${process.env.PUBLIC_URL}` === '/examineAdmin' ? <Route path="/Main" element={<Main />} /> : null}
              {`${process.env.PUBLIC_URL}` === '/examineAdmin' ? <Route path="/MedicalRecords" element={<MedicalRecords />} /> : null}
              {`${process.env.PUBLIC_URL}` === '/examineAdmin' ? <Route path="/AdminLogin" element={<AdminLogin />} /> : null}
              {`${process.env.PUBLIC_URL}` === '/examineAdmin' ? <Route path="/MinmaxQuery" element={<MinmaxQuery />} /> : null}
              {`${process.env.PUBLIC_URL}` === '/examineAdmin' ? <Route path="/GenerateReport" element={<GenerateReport />} /> : null}
              {`${process.env.PUBLIC_URL}` === '/examineAdmin' ? <Route path="/LaborCheckForm" element={<LaborCheckForm />} /> : null}
              {`${process.env.PUBLIC_URL}` === '/examineAdmin' ? <Route path="/GeneralForm" element={<GeneralForm />} /> : null}
              {`${process.env.PUBLIC_URL}` === '/examineAdmin' ? <Route path="/AnnualReport" element={<AnnualReport />} /> : null}
              {`${process.env.PUBLIC_URL}` === '/examineAdmin' ? <Route path="/AnnualReportCustomer" element={<AnnualReportCustomer />} /> : null}
              {`${process.env.PUBLIC_URL}` === '/examineAdmin' ? <Route path="/QueryLostitem" element={<QueryLostitem />} /> : null}

              <Route path="/*" element={<MinmaxLogin />} />
              <Route path="/Login" element={<MinmaxLogin />} />
              <Route path="/Admin" element={<PrivateRoute><MinmaxQuery2 /></PrivateRoute>} />

            </Routes>

          </Router>
        </SnackbarProvider>
      </IntlProvider>

    </ThemeProvider >
  )

}
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <InitialSetting />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
